module.exports = __webpack_public_path__ + "media/1.bfa76bc9.mp3";